import type { ReactNode } from "react";
import { useTheme } from "#shared/hooks/use-theme.ts";

export function RootLayout({ children }: { children: ReactNode }) {
  useTheme();
  return <>{children}</>;
}
